module.exports = __webpack_public_path__ + "static/ORIO-G80112D5-NB-97cf37ca7b08467486fd93722174487e.png";